import { Chakra } from "@airhelp/react-ui-components";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Stars } from "./Stars";
import { CollapsibleText } from "./CollapsibleText";
import type { ReviewCardProps } from "./ReviewCard.d";

const { Box, Flex, Text } = Chakra;

export const ReviewCard = ({
  review,
  isHero,
  width = { base: "calc(100vw - 2rem)", md: "382px" },
  ...props
}: ReviewCardProps) => {
  const {
    consumer: { displayName, displayLocation },
    createdAt,
    text,
  } = review;

  dayjs.extend(relativeTime);

  return (
    <Flex
      data-testid="review-card"
      w={width}
      bg="white"
      p={{ base: 4, md: 6 }}
      border="1px solid"
      borderColor="greyscale.400"
      borderRadius="lg"
      flexDir="column"
      justify="space-between"
      color="primary.900"
      {...props}
    >
      <Box mb={5}>
        <Flex justify="space-between" mb={9}>
          <Stars />
          <Text fontSize="sm" lineHeight="shorter" color="greyscale.600">
            {createdAt && dayjs(createdAt).fromNow()}
          </Text>
        </Flex>
        {isHero ? (
          <Text fontSize="sm" fontWeight="semibold" lineHeight={1.5}>
            {text}
          </Text>
        ) : (
          <CollapsibleText text={text} />
        )}
      </Box>
      <Flex>
        <Flex flexDir="column" justify="center">
          <Text mb={0} fontSize="sm" lineHeight="shorter" fontWeight="semibold">
            {displayName}
          </Text>
          <Text fontSize="sm" lineHeight="shorter" color="greyscale.600">
            {displayLocation}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
